/**
파일명: PageRouter.jsx
설명: 라우트 메타데이터를 실제 페이지 컴포넌트로 매핑해 렌더링하는 라우터 컴포넌트입니다.
*/

import HomePage from './home/HomePage';
import SolutionPage from './solution/SolutionPage';
import FaqPage from './cs/FaqPage';
import ContactPage from './cs/ContactPage';
import CompanyAboutPage from './company/CompanyAboutPage';
import CompanyGreetingsPage from './company/CompanyGreetingsPage';
import CompanyCustomersPage from './company/CompanyCustomersPage';
import CompanyHistoryPage from './company/CompanyHistoryPage';
import CompanyMaintenancePage from './company/CompanyMaintenancePage';
import NewsListPage from './news/NewsListPage';
import NewsDetailPage from './news/NewsDetailPage';
import AdminPage from './admin/AdminPage';
import NotFoundPage from './NotFoundPage';

function renderPageByRoute(route, onNavigate) {
  // [비즈니스] URL 규칙별로 올바른 페이지를 보여줘 정보 탐색 흐름을 보장합니다.
  // [기능] route.page 값을 기준으로 대응되는 페이지 컴포넌트를 반환합니다.
  // [기술] switch 분기로 페이지 매핑을 명시화해 신규 페이지 추가 시 변경 지점을 단순화합니다.
  switch (route.page) {
    case 'home':
      return <HomePage onNavigate={onNavigate} />;
    case 'companyAbout':
      return <CompanyAboutPage onNavigate={onNavigate} />;
    case 'companyCeo':
      return <CompanyGreetingsPage onNavigate={onNavigate} />;
    case 'companyHistory':
      return <CompanyHistoryPage />;
    case 'companyCustomers':
      return <CompanyCustomersPage onNavigate={onNavigate} />;
    case 'companyMaintenance':
      return <CompanyMaintenancePage onNavigate={onNavigate} />;
    case 'solution':
      return <SolutionPage activeTab={route.activeTab} onNavigate={onNavigate} />;
    case 'newsList':
      return <NewsListPage onNavigate={onNavigate} />;
    case 'newsDetail':
      return <NewsDetailPage slug={route.slug} onNavigate={onNavigate} />;
    case 'faq':
      return <FaqPage />;
    case 'contact':
      return <ContactPage onNavigate={onNavigate} />;
    case 'admin':
      return <AdminPage activeTab={route.adminTab} onNavigate={onNavigate} />;
    default:
      return <NotFoundPage onNavigate={onNavigate} />;
  }
}

export default function PageRouter({ route, onNavigate }) {
  // [비즈니스] App 계층이 라우팅 구현 세부사항을 몰라도 페이지 렌더링을 수행할 수 있게 합니다.
  // [기능] 전달받은 route를 renderPageByRoute에 위임해 최종 페이지 요소를 반환합니다.
  // [기술] 렌더 함수 분리를 통해 라우팅 분기 로직을 컴포넌트 본문과 분리합니다.
  return renderPageByRoute(route, onNavigate);
}
